// Central business data + SEO helpers. Contact details are placeholders — swap freely.
export const SITE = {
  name: "Sankofa Launch Studio",
  tagline: "Rooted in insight. Built for tomorrow.",
  url: "https://rooted-tomorrow.preview.emergentagent.com",
  description:
    "Sankofa Launch Studio designs and builds fast, reliable, mobile-first websites, online shops, booking sites and web apps for Ghanaian schools, hotels and growing businesses — and hosts and maintains them afterwards.",
  // ---- Contact (PLACEHOLDERS — replace with real details) ----
  whatsappDisplay: "+233 54 822 7381",
  whatsappNumber: "233548227381",
  phoneDisplay: "+233 54 822 7381",
  email: "sankofalaunchstudio@gmail.com",
  city: "Accra",
  addressLine: "Accra, Ghana",
  priceRange: "GHS 2,200 – GHS 14,000+",
};

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
    text || "Hello Sankofa Launch Studio, I'd like to book a free briefing."
  )}`;

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "For Schools", to: "/schools" },
  { label: "For Hotels", to: "/hotels" },
  { label: "Pricing", to: "/pricing" },
  { label: "How We Work", to: "/process" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

// LocalBusiness / ProfessionalService schema, reused on every page.
export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE.url}/#business`,
  name: SITE.name,
  description: SITE.description,
  slogan: SITE.tagline,
  url: SITE.url,
  telephone: SITE.phoneDisplay,
  email: SITE.email,
  image: `${SITE.url}/favicon.png`,
  logo: `${SITE.url}/favicon.png`,
  priceRange: SITE.priceRange,
  address: {
    "@type": "PostalAddress",
    addressLocality: SITE.city,
    addressCountry: "GH",
  },
  areaServed: { "@type": "Country", name: "Ghana" },
  sameAs: [],
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE.url}${it.path}`,
  })),
});

export const serviceSchema = (name, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name,
  description,
  provider: { "@id": `${SITE.url}/#business` },
  areaServed: { "@type": "Country", name: "Ghana" },
});
